"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("../../components/SvgIcon"));
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], Object.assign({
    viewBox: '0 0 16 15'
  }, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: 'currentColor',
    d: "M2,15 C0.897333333,15 0,14.1026667 0,13 L0,2 C0,0.897333333 0.897333333,0 2,0 L12.5,0 C13.3273333,0 14,0.672666667 14,1.5 L14,2.586 C14.59,2.79533333 15,3.36066667 15,4 L15,6.086 C15.59,6.29466667 16,6.86 16,7.5 L16,10.5 C16,11.14 15.59,11.7053333 15,11.914 L15,13.5 C15,14.3273333 14.3273333,15 13.5,15 L2,15 Z M2,1 C1.44866667,1 1,1.44866667 1,2 L1,13 C1,13.5513333 1.44866667,14 2,14 L13.5,14 C13.776,14 14,13.776 14,13.5 L14,12 L12,12 C10.346,12 9,10.654 9,9 C9,7.346 10.346,6 12,6 L14,6 L14,4 C14,3.724 13.776,3.5 13.5,3.5 L3.75,3.5 C3.736,3.50066667 3.71066667,3.50133333 3.68466667,3.50133333 C3.08733333,3.50133333 2.53333333,3.174 2.238,2.648 C2.10333333,2.40733333 2.18866667,2.102 2.42933333,1.96733333 C2.504,1.92533333 2.58866667,1.90333333 2.674,1.90333333 C2.85466667,1.90333333 3.022,2.00133333 3.11,2.15866667 C3.23066667,2.37333333 3.448,2.50133333 3.69266667,2.50133333 L3.726,2.50066667 L13,2.5 L13,1.5 C13,1.224 12.776,1 12.5,1 L2,1 Z M12,7 C10.8973333,7 10,7.89733333 10,9 C10,10.1026667 10.8973333,11 12,11 L14.5,11 C14.776,11 15,10.776 15,10.5 L15,7.5 C15,7.224 14.776,7 14.5,7 L12,7 Z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "12",
    cy: "9",
    r: "1"
  }));
});